export default "__VITE_ASSET__Cy8xWZNO__"